import { Loader2Icon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

export interface ConnectorProviderCardContentProps {
  providerSlug: string
  providerDisplayName: string
  isConnected: boolean
  connectedAccountEmail: string | null
  isConnecting: boolean
  onConnect: (providerSlug: string) => void
  onDisconnect: (providerSlug: string) => void
}

/**
 * Content section for a connector provider card.
 * Shows connected account info or a connect button.
 */
export const ConnectorProviderCardContent = ({
  providerSlug,
  providerDisplayName,
  isConnected,
  connectedAccountEmail,
  isConnecting,
  onConnect,
  onDisconnect,
}: ConnectorProviderCardContentProps): ReactNode => {
  if (isConnected) {
    return (
      <fieldset className="flex items-center justify-between border-none p-0 m-0">
        <p className="text-muted-foreground text-sm">
          Connected as <span className="text-foreground font-medium">{connectedAccountEmail}</span>
        </p>
        <Button
          variant="ghost"
          size="sm"
          className="connector-disconnect-button text-destructive hover:text-destructive"
          onClick={() => onDisconnect(providerSlug)}
        >
          Disconnect
        </Button>
      </fieldset>
    )
  }

  return (
    <Button
      className="connector-connect-button"
      onClick={(e) => {
        e.stopPropagation()
        onConnect(providerSlug)
      }}
      disabled={isConnecting}
    >
      {isConnecting && <Loader2Icon className="mr-2 size-4 animate-spin" />}
      Connect {providerDisplayName}
    </Button>
  )
}

ConnectorProviderCardContent.displayName = 'ConnectorProviderCardContent'
